import { NOMATIM_SERVICE } from "@/services/nomatim.service.js";

const state = { getAddressOutput: {}};

const actions = {
    getAddress({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('getAddressRequest');

        NOMATIM_SERVICE.getAddress(input.latitude, input.longitude)
            .then(
                output => {
                    commit('getAddressSuccess', output);
                },
                error => {
                    commit('getAddressFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getAddress
    getAddressRequest(state) {
    },
    getAddressSuccess(state, output) {
        state.getAddressOutput = output;
    },
    getAddressFailure(state) {
        state.getAddressOutput = false;
    },
};

export const nomatim = {
    namespaced: true,
    state,
    actions,
    mutations
};